import { graphql, useLazyLoadQuery } from "react-relay"
import type { useIsAutoTranslationEnabledQuery } from "@/modules/chats/hooks/__generated__/useIsAutoTranslationEnabledQuery.graphql"

const autoTranslationFeatureFlagQuery = graphql`
  query useIsAutoTranslationEnabledQuery {
    featureFlags(featureFlags: [CHAT_AUTO_TRANSLATION]) {
      featureFlag
      isEnabled
    }
  }
`

export const useIsAutoTranslationEnabled = () => {
  const result = useLazyLoadQuery<useIsAutoTranslationEnabledQuery>(autoTranslationFeatureFlagQuery, {})
  return result.featureFlags.some((f) => f.featureFlag === "CHAT_AUTO_TRANSLATION" && f.isEnabled)
}
